<div class="row" *ngIf="isComercial || isBasica">
    <div class="col-lg col-md col-xs col-xl col-sm w-100">
        <mat-card class="mat-elevation-z8 w-100">
            <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
                <div class="row">
                    <div class="col-lg col-md col-xs col-xl col-sm">
                        <p class="tituloLeft">{{step}}</p>
                    </div>
                    <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
                        <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
                            *ngIf="!collapseCard"></i>
                        <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
                            *ngIf="collapseCard"></i>
                    </div>
                </div>
                <mat-card-content *ngIf="!collapseCard">

                    <div class="row pt-3 mt-2">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Início Secagem Data</mat-label>
                                <input matInput id="txtIniSecagemData" #txtIniSecagemData maxlength="10"
                                    [dropSpecialCharacters]="false" mask="d0/M0/0000"
                                    formControlName="Inicio_secagem_data" (blur)="makeCalculations()"
                                    (blur)="alertaData()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                    {{hintDate}}</mat-hint>
                                <mat-hint align="end">{{txtIniSecagemData.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Inicio_secagem_data)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Início Secagem Hora</mat-label>
                                <input matInput id="txtIniSecagemHora" #txtIniSecagemHora maxlength="5"
                                    [dropSpecialCharacters]="false" formControlName="Inicio_secagem_hora" mask="Hh:m0"
                                    (blur)="makeCalculations()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                    {{hintHour}}</mat-hint>
                                <mat-hint align="end">{{txtIniSecagemHora.value.length}} / 5</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Inicio_secagem_hora)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Inversão Câmara Data</mat-label>
                                <input matInput id="txtInvCamaraData" #txtInvCamaraData maxlength="10" mask="d0/M0/0000"
                                    formControlName="Inversao_camara_data" (blur)="makeCalculations()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                    {{hintDate}}</mat-hint>
                                <mat-hint align="end">{{txtInvCamaraData.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Inversao_camara_data)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Inversão Câmara Hora</mat-label>
                                <input matInput id="txtInvCamaraHora" #txtInvCamaraHora maxlength="5" mask="Hh:m0"
                                    formControlName="Inversao_camara_hora" (blur)="makeCalculations()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                    {{hintHour}}</mat-hint>
                                <mat-hint align="end">{{txtInvCamaraHora.value.length}} / 5</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Inversao_camara_hora)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Data Amostragem</mat-label>
                                <input matInput id="txtDataAmostragem" #txtDataAmostragem maxlength="10"
                                    mask="d0/M0/0000" formControlName="data_amostragem">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintDate}}</mat-hint>
                                <mat-hint align="end">{{txtDataAmostragem.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.data_amostragem)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Hora Amostragem</mat-label>
                                <input matInput id="txtHoraAmostragem" #txtHoraAmostragem maxlength="5" mask="Hh:m0"
                                    formControlName="hora_amostragem">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintHour}}</mat-hint>
                                <mat-hint align="end">{{txtHoraAmostragem.value.length}} / 5</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.hora_amostragem)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Umidade da Amostra</mat-label>
                                <input matInput id="txtUmidadeAmostra" #txtUmidadeAmostra maxlength="5"
                                    formControlName="umidade_amostra"
                                    [options]="{ thousands: '.', decimal: ',', precision: 2 }" currencyMask>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                                <mat-hint align="end">{{txtUmidadeAmostra.value.length}} / 5</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.umidade_amostra)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Foi atualizado o OPTEK com o resultado da
                                    amostragem?</mat-label>
                                <mat-select #txtOptek formControlName="optek_amostra" disableCenteringOption>
                                    <mat-option *ngFor="let item of listOpetkOption" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-error>{{hasErrorFormControl(formulario.controls.optek_amostra)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Término Secagem Data</mat-label>
                                <input matInput id="txtTermSecagemData" #txtTermSecagemData maxlength="10"
                                    [dropSpecialCharacters]="false" mask="d0/M0/0000"
                                    formControlName="Termino_secagem_data" (blur)="makeCalculations()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                    {{hintDate}}</mat-hint>
                                <mat-hint align="end">{{txtTermSecagemData.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Termino_secagem_data)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Término Secagem Hora</mat-label>
                                <input matInput id="txtTermSecagemHora" #txtTermSecagemHora maxlength="5" mask="Hh:m0"
                                    [dropSpecialCharacters]="false" formControlName="Termino_secagem_hora"
                                    (blur)="makeCalculations()" (blur)="alertaData()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                    {{hintHour}}</mat-hint>
                                <mat-hint align="end">{{txtTermSecagemHora.value.length}} / 5</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Termino_secagem_hora)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Umidade Topo de Fechamento M%Off</mat-label>
                                <input matInput id="txtUmidFechTopo" #txtUmidFechTopo maxlength="5"
                                    formControlName="Umidade_topo_de_fechamento_moff" currencyMask>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="end">{{txtUmidFechTopo.value.length}} / 5</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Umidade_topo_de_fechamento_moff)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Umidade Média de Fechamento AvM%</mat-label>
                                <input matInput id="txtUmidMediaFechAv" #txtUmidMediaFechAv maxlength="5"
                                    formControlName="Umidade_media_fechamento_av" currencyMask>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="end">{{txtUmidMediaFechAv.value.length}} / 5</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Umidade_media_fechamento_av)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-md-6">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Ressecagem</mat-label>
                                <input matInput id="txtRessecagem" #txtRessecagem maxlength="100"
                                    formControlName="Ressecagem" [matAutocomplete]="auto" [readonly]="isReadonly"
                                    (blur)="checkRessecagem()" (blur)="makeCalculations()"
                                    [ngClass]="{'InputBlockColor': isReadonly}">
                                <mat-autocomplete #auto="matAutocomplete">
                                    <mat-option *ngFor="let item of filterOptionsRessecagem | async"
                                        [value]="item.name">
                                        {{item.name}}
                                    </mat-option>
                                </mat-autocomplete>
                                <i matSuffix *ngIf="isReadonly" class="{{iconDisableField}}"></i>
                                <mat-hint align="end">{{txtRessecagem.value.length}} / 100</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Ressecagem)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md-6">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                              <mat-label class="InputLabelColor">Altura Camada (m)</mat-label>
                              <input matInput id="txtAlturaCamada" #txtAlturaCamada maxlength="5" formControlName="Altura_camada_m"
                                currencyMask>
                              <i matSuffix class="{{iconEnableField}}"></i>
                              <mat-hint align="start" class="InputLabelDetailsColor">
                                {{hintNumber}}
                              </mat-hint>
                              <mat-hint align="end">{{txtAlturaCamada.value.length}} / 5</mat-hint>
                              <mat-error>{{hasErrorFormControl(formulario.controls.Altura_camada_m)}}</mat-error>
                              <mat-error *ngIf="formulario.controls['Altura_camada_m'].hasError('max')">
                                O valor máximo permitido é 4,50 m.
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Avaliação De Nivelamento</mat-label>
                                <mat-select #txtNivelamento formControlName="avaliacao_nivelamento" (blur)="blockField()" disableCenteringOption>
                                    <mat-option *ngFor="let item of listOptionNivelamento" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-error>{{hasErrorFormControl(formulario.controls.avaliacao_nivelamento)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Observação</mat-label>
                                <textarea placeholder="Ex: Não satisfatorio devido a altura da camada baixa" matInput id="txtObs" #txtObs maxlength="255"
                                    formControlName="observacao_nivelamento"></textarea>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="end">{{txtObs.value.length}} / 255</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.observacao_nivelamento)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Início Ressecagem Data</mat-label>
                                <input matInput id="txtIniRessecagemData" #txtIniRessecagemData maxlength="10"
                                    [dropSpecialCharacters]="false" mask="d0/M0/0000"
                                    formControlName="Inicio_ressecagem_data" (blur)="checkRessecagem()"
                                    (blur)="makeCalculations()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                    {{hintDate}}</mat-hint>
                                <mat-hint align="end">{{txtIniRessecagemData.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Inicio_ressecagem_data)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Início Ressecagem Hora</mat-label>
                                <input matInput id="txtIniRessecagemHora" #txtIniRessecagemHora maxlength="5"
                                    [dropSpecialCharacters]="false" mask="Hh:m0"
                                    formControlName="Inicio_ressecagem_hora" (blur)="makeCalculations()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                    {{hintHour}}</mat-hint>
                                <mat-hint align="end">{{txtIniRessecagemHora.value.length}} / 5</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Inicio_ressecagem_hora)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Término Ressecagem Data</mat-label>
                                <input matInput id="txtFimRessecagemData" #txtFimRessecagemData maxlength="10"
                                    [dropSpecialCharacters]="false" mask="d0/M0/0000"
                                    formControlName="Termino_ressecagem_data" (blur)="makeCalculations()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                    {{hintDate}}</mat-hint>
                                <mat-hint align="end">{{txtFimRessecagemData.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Termino_ressecagem_data)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Término Ressecagem Hora</mat-label>
                                <input matInput id="txtFimRessecagemHora" #txtFimRessecagemHora maxlength="5"
                                    [dropSpecialCharacters]="false" mask="Hh:m0"
                                    formControlName="Termino_ressecagem_hora" (blur)="makeCalculations()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                    {{hintHour}}</mat-hint>
                                <mat-hint align="end">{{txtFimRessecagemHora.value.length}} / 5</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Termino_ressecagem_hora)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </mat-card-content>
            </form>
        </mat-card>
    </div>
</div>


<div class="row" *ngIf="isPreBasica">
    <div class="col-lg col-md col-xs col-xl col-sm w-100">
        <mat-card class="mat-elevation-z8 w-100">
            <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
                <div class="row">
                    <div class="col-lg col-md col-xs col-xl col-sm">
                        <p class="tituloLeft">{{step}}</p>
                    </div>
                    <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
                        <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
                            *ngIf="!collapseCard"></i>
                        <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
                            *ngIf="collapseCard"></i>
                    </div>
                </div>
                <mat-card-content *ngIf="!collapseCard">
                    <div class="row pt-3">
                        <div class="col-lg col-md col-xs col-sm col-xl text-right">
                            <button mat-flat-button color="primary" class="btnSizeLarge" matTooltip="Adicionar"
                                (click)="addItem()">
                                <i class="fa fa-plus fa-1x btnIcon"></i> Adicionar Secagem
                            </button>
                            <button mat-flat-button color="primary" class="btnSizeLarge" matTooltip="Remover"
                                (click)="removeItem()" [disabled]="disabledBtnRemove">
                                <i class="fa fa-minus fa-1x btnIcon"></i> Remover Secagem
                            </button>
                        </div>
                    </div>

                    <ng-template #viewContainerRef></ng-template>

                </mat-card-content>

            </form>
        </mat-card>
    </div>
</div>